import { cloneElement, type ReactElement } from "react";

import { type IconProps } from "../Icon";
import { type IconButtonProps, type IconColor } from "./variants";

/**
 * variant="subtle"でcolor指定時、Icon childrenにcolor propを渡す
 * disabled状態の場合はcolorを適用しない
 */
export const applyIconColor = ({
  icon,
  variant,
  color,
  disabled,
}: {
  icon: ReactElement<Omit<IconProps, "color">>;
  variant: IconButtonProps["variant"];
  color: IconButtonProps["color"];
  disabled?: boolean;
}): ReactElement<IconProps> => {
  if (variant === "subtle" && color && !disabled) {
    return cloneElement(icon as ReactElement<IconProps>, {
      color: color as IconColor,
    });
  }
  return icon as ReactElement<IconProps>;
};
